import React, { useState, useContext, useEffect, Fragment } from 'react';
import YesNo from '../../../../../components/Dialog/YesNo';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from '../../../../../api/axios';
import { useParams } from 'react-router-dom';
import { store as mainStore } from '../../../../../store';
import { store } from './Tendering';
import Progressbar from '@material-ui/core/LinearProgress';
import moment from 'moment-jalaali';
import { toEN, formatNumber, rond } from '../../../../../fns';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const DriverProposeDialog = ({ open, onClose, driver, refetch }) => {
  const classes = useStyles();

  const { id: orderId } = useParams();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    dispatch,
    state: { order, params },
    actions: { fetchingBidders },
    refresh,
  } = useContext(store);
  const proposedPrice = order && order.proposedPrice ? order.proposedPrice : 0;
  const [propose, setPropose] = useState(0);
  const [loadingPropose, setLoadingPropose] = useState(false);

  const handleChangeText = (e) => {
    let { value } = e.target;
    value = toEN(value);
    setPropose(value);
  };
  const handleClose = async (agree) => {
    if (agree) {
      try {
        setLoadingPropose(true);
        const {
          data: { messages, order },
        } = await axios.post(`/api/v1/admin/orders/tendering/addDriverBid`, {
          orderId,
          driverId: driver._id,
          propose,
        });
        refetch();
        // await fetchingBidders(orderId, 1, itemsCountPerPage);
        showMessage(messages);
        // await refresh();
      } catch (error) {
        showError(error);
      } finally {
        setLoadingPropose(false);
      }
    }
    onClose();
  };

  useEffect(() => {
    (async () => {
      const { data } = await axios.get(
        `api/v1/admin/orders/tendering/getDriverPropose/${orderId}/${driver._id}`
      );
      data && data.propose && setPropose(data.propose);
    })();
  }, []);
  useEffect(() => {
    if (params && !propose) {
      setPropose(proposedPrice * 1 - params.subs * 1);
    }
  }, [params]);

  return (
    <YesNo
      yes="ثبت"
      no="صرفنظر"
      onClose={handleClose}
      open={open}
      title="ثبت پیشنهاد مبلغ حمل بار"
      loadingButton
      startIcon={<CircularProgress size={'15px'} />}
      inProgress={loadingPropose}
    >
      {params && (
        <div className={classes.root}>
          <Divider />
          <TextField
            fullWidth
            variant="outlined"
            label="مبلغ پیشنهادی از طرف راننده"
            value={propose > 0 ? formatNumber(propose) : ''}
            onChange={handleChangeText}
          />
          <div>
            + جمع سایرکارمزدها <span>{formatNumber(params?.subs || 0)}</span>{' '}
            تومان
          </div>
          <Divider />
          <div>
            = مبلغ اعلامی به صاحب بار{' '}
            <span>{formatNumber(params?.subs + propose * 1)}</span> تومان
          </div>
        </div>
      )}
    </YesNo>
  );
};

export default React.memo(DriverProposeDialog);
